export interface UserSystemSettings {
  year: string;
  idDonVi: number;
  perpage: number;
}

export const DEFAULT_PER_PAGE = 50;

export const PER_PAGE_OPTIONS = [10, 20, 30, 50, 100, 200];
